import React, { useState } from 'react';
import { Box, Stack, Button, TextField, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFormikContext, getIn } from 'formik';
import EmpModalContainer from '../../../containers/common/form/modal/EmpModalContainer';
import NumberFormatText from '../../common/form/NumberFormatText';
import FormLabel from '../../common/form/FormLabel';

const RoInternalCostsForm = ({
  cost,
  index,
  touched,
  errors,
  handleRemove,
  handleChange,
  handleBlur,
  totalSales,
  handleRoAdj,
}) => {
  const formikProps = useFormikContext();

  const [openEmp, setOpenEmp] = useState(false);
  const [title, setTitle] = useState('사원찾기');

  const roPartnerUsrNm = `roInternalCosts[${index}].roPartnerUsrNm`;
  const touchedRoPartnerUsrNm = getIn(touched, roPartnerUsrNm);
  const errorRoPartnerUsrNm = getIn(errors, roPartnerUsrNm);

  const roPartnerUsr = `roInternalCosts[${index}].roPartnerUsr`;

  const roInternalAmt = `roInternalCosts[${index}].roInternalAmt`;
  const touchedRoInternalAmt = getIn(touched, roInternalAmt);
  const errorRoInternalAmt = getIn(errors, roInternalAmt);

  const roInternalAmtPercent = `roInternalCosts[${index}].roInternalAmtPercent`;
  const touchedRoInternalAmtPercent = getIn(touched, roInternalAmtPercent);
  const errorRoInternalAmtPercent = getIn(errors, roInternalAmtPercent);

  const openEmpModal = (type, title) => {
    setTitle(title);
    setOpenEmp(true);
  };
  const handleEmpClose = () => {
    setOpenEmp(false);
  };

  const selectedEmployee = (emp) => {
    formikProps.setFieldValue(roPartnerUsrNm, emp.usrNm, true);
    formikProps.setFieldValue(roPartnerUsr, emp.usrUuid, true);
  };

  //전체갑(totalSales)에서 매출이익은 몇 %일까?
  const handleChangeCost = () => {
    //const numberTotalSales = Number( totalSales);
    const numberTotalSales = Number(formikProps.values?.roProfitAmt);

    const numberValue = Number(
      formikProps.values.roInternalCosts[index].roInternalAmt,
    );
    const percent = Math.round((numberValue / numberTotalSales) * 100);

    formikProps.setFieldValue(roInternalAmtPercent, percent, false);
  };

  const handleChangePercent = () => {
//    const numberTotalSales = Number(totalSales);
    const numberTotalSales = Number(formikProps.values?.roProfitAmt);
    const numberPercent = Number(
      formikProps.values.roInternalCosts[index].roInternalAmtPercent,
    );
    const numberValue = Math.round(numberTotalSales * (numberPercent / 100));

    formikProps.setFieldValue(roInternalAmt, numberValue, false);

  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        p: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box sx={{ width: '180px' }}>
          <FormLabel textAlign="center">협업본부 영업담당</FormLabel>
        </Box>
        <Box>
          <TextField
            size="small"
            required={true}
            variant="outlined"
            disabled
            fullWidth
            id={roPartnerUsrNm}
            name={roPartnerUsrNm}
            value={formikProps.values.roInternalCosts[index].roPartnerUsrNm}
            error={touchedRoPartnerUsrNm && Boolean(errorRoPartnerUsrNm)}
            helperText={touchedRoPartnerUsrNm && errorRoPartnerUsrNm}
          />
        </Box>
        <Box>
          <Button
            type="button"
            variant="outlined"
            size="small"
            onClick={() => openEmpModal('', '협업본부 영업담당 선택')}
          >
            협업본부 영업담당 선택
          </Button>
        </Box>
        <Box>
          <TextField
            size="small"
            required
            variant="outlined"
            fullWidth
            id={roInternalAmt}
            name={roInternalAmt}
            value={formikProps.values.roInternalCosts[index].roInternalAmt}
            onChange={(e) =>
              formikProps.setFieldValue(roInternalAmt, Number(e.target.value))
            }
            onBlur={() => {
              handleChangeCost();
              handleRoAdj();
            }}
            error={touchedRoInternalAmt && Boolean(errorRoInternalAmt)}
            helperText={touchedRoInternalAmt && errorRoInternalAmt}
            InputProps={{
              inputComponent: NumberFormatText,
            }}
          />
        </Box>
        <Box>
          <TextField
            size="small"
            required
            variant="outlined"
            fullWidth
            id={roInternalAmtPercent}
            name={roInternalAmtPercent}
            value={
              formikProps.values.roInternalCosts[index].roInternalAmtPercent
            }
            onChange={(e) =>{
              formikProps.setFieldValue(
                roInternalAmtPercent,
                Number(e.target.value),
              ); 
              
              }
            }
            onBlur={() => {
              handleChangePercent();
              handleRoAdj();
            }}
            error={
              touchedRoInternalAmtPercent && Boolean(errorRoInternalAmtPercent)
            }
            helperText={
              touchedRoInternalAmtPercent && errorRoInternalAmtPercent
            }
            InputProps={{
              inputComponent: NumberFormatText,
            }}
            sx={{ width: 80 }}
          />
        </Box>
        <Box>%</Box>
        <Box>
          <IconButton color="error" aria-label="delete" onClick={handleRemove}>
            <DeleteIcon />
          </IconButton>
        </Box>
      </Stack>
      {openEmp && (
        <EmpModalContainer
          title={title}
          multi={false}
          open={openEmp}
          handleClose={handleEmpClose}
          selectedEmployee={selectedEmployee}
        />
      )}
    </Box>
  );
};

export default RoInternalCostsForm;
